import { useState } from "react";
import { Tabs } from "antd";
import InboundFaxManagementPage from "./InboundFaxManagementPage";
import InboundFaxReviewPage from "./InboundFaxReviewPage";

export default function InboundFaxUnifiedPage() {
  const [activeTab, setActiveTab] = useState("incoming");
  return (
    <section className="fax-workspace">
      <header className="fax-workspace-header">
        <h1>Inbound faxes</h1>
        <p>Classify documents, track prescriptions, and confirm resident matches.</p>
      </header>
      <Tabs className="fax-navigation" activeKey={activeTab} onChange={setActiveTab} items={[
        { key: "incoming", label: "Incoming" },
        { key: "prescription", label: "Prescription List" },
        { key: "review", label: "Review Queue" },
      ]} />
      {activeTab === "review" ? <InboundFaxReviewPage /> : (
        <InboundFaxManagementPage activeTab={activeTab} onNavigate={setActiveTab} />
      )}
    </section>
  );
}
